import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import MarketCard from "@/components/MarketCard";
import { useI18n } from "@/lib/i18n";

export default function Live() {
    const [markets, setMarkets] = useState([]);
    const [loading, setLoading] = useState(true);
    const { t } = useI18n();

    useEffect(() => {
        const fetch = () =>
            api.get("/markets", { params: { is_live: true, limit: 48 } }).then((r) => setMarkets(r.data));
        fetch().finally(() => setLoading(false));
        const i = setInterval(fetch, 15000);
        return () => clearInterval(i);
    }, []);

    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12" data-testid="live-page">
            <div className="flex items-center gap-3 mb-2">
                <span className="w-3 h-3 rounded-full bg-p2w-magenta animate-pulse-dot shadow-glow-magenta" />
                <span className="text-xs uppercase tracking-[0.3em] font-sora font-bold text-p2w-magenta">
                    {t("market.live")}
                </span>
            </div>
            <h1 className="font-sora font-extrabold text-4xl sm:text-5xl tracking-tighter text-white">
                {t("home.live_title")}
            </h1>
            <p className="mt-2 text-p2w-gray">{t("home.live_sub")}</p>

            <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {loading
                    ? Array.from({ length: 6 }).map((_, i) => (
                          <div key={i} className="h-72 rounded-2xl bg-p2w-surface border border-p2w-line animate-pulse" />
                      ))
                    : markets.map((m) => <MarketCard key={m.id} market={m} />)}
            </div>
            {!loading && markets.length === 0 && (
                <div className="text-center py-16 text-p2w-gray">No hay mercados en vivo ahora.</div>
            )}
        </div>
    );
}
